var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"outline":"","color":"blue-grey darken-8"},on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Retornar")]),_c('img',{staticClass:"logo-404",attrs:{"width":"400","src":require('../assets/404.png'),"alt":"protalk 404"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8a08dd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error404.vue
// module id = 1192
// module chunks = 0